const Get_User = () => {
  const item = Get_Current_User();
  if (item == null) {
    return null;
  }
  return item.UserInfo;
};

const Get_Token = () => {
  const item = Get_Current_User();
  if (item == null) {
    return item;
  }
  return item.Token;
};

const Get_Login = () => {
  return Get_Current_User();
};

const Set_User = (value, ttl) => {
  const decodedJwt = parseJwt(value.Token);
  const item = {
    UserInfo: value.User,
    Token: value.Token,
    Menu: value.Menu,
    expiry: decodedJwt.exp * 1000,
  };
  localStorage.setItem("User", JSON.stringify(item));
};

const Update_Users_Profile = (newData) => {
  const User = localStorage.getItem("User");
  const user_ = JSON.parse(User);
  const updatedUser = {
    ...user_,
    UserInfo: {
      ...user_.UserInfo,
      User_Photo_Path: newData.profilePictureURL,
      fullName: newData.fullName,
    },
  };
  localStorage.setItem("User", JSON.stringify(updatedUser));
};

const Get_Current_User = () => {
  const itemStr = localStorage.getItem("User");
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    localStorage.clear();
    window.location.href = "/";
    return false;
  }
  return item;
};

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export default {
  Get_User,
  Get_Token,
  Get_Login,
  Set_User,
  Update_Users_Profile,
};
